/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Variant_NoteInputs */

const vi_shop_variant_note = /** @type {(inputs: Shop_Variant_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kéo ⋮⋮ đổi thứ tự loại (loại đầu còn hàng = chọn sẵn). "Có sẵn hàng" tick tay: bỏ tick = khách không đặt được. Giá, tồn đọc từ ERP, không sửa ở đây.`)
};

/**

* @param {Shop_Variant_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_variant_note = /** @type {((inputs?: Shop_Variant_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Variant_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_variant_note(inputs)
});